import { Component, RendererFactory2 } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { ChartOptions } from 'chart.js'
import { Color, Label } from 'ng2-charts'
import { ModalComponent } from 'src/app/components/modal/modal.component'
import { PrintService } from 'src/app/_shared/services/print.service'
import { OrderService } from '../../services/order.service'
import * as XLSX from 'xlsx'
import * as FileSaver from 'file-saver'
import { OrderSummary } from '../../agrishop.interface'
@Component({
  selector: 'app-orderstats',
  templateUrl: './orderstats.component.html',
  styleUrls: ['./orderstats.component.scss'],
})
export class OrderStatsComponent extends ModalComponent {
  offLineDataLabels: Label[] = ['Online Orders', 'Offline Orders']

  public doughnutChartColors: Color[] = [
    {
      backgroundColor: ['#D693DA', '#7ABB89'],
    },
  ]
  public options: ChartOptions = {
    legend: {
      position: 'right',
      labels: {
        padding: 5,
      },
    },
  }
  dateRange: Date[]
  constructor(
    private router: Router,
    renderFactory: RendererFactory2,
    private route: ActivatedRoute,
    public printService: PrintService,
    public orderService: OrderService
  ) {
    super(renderFactory)
  }

  async ngOnInit() {
    this.dateRange = this.orderService.summaryDateRange
    if (this.route.snapshot.data.print) {
      this.printService.onDataReady()
    }
    await this.orderService.getOrderStats().toPromise()
  }

  onPrint() {
    this.printService.printDocument('stats')
  }

  onExport(data: OrderSummary) {
    let origin = 2
    const fileName = 'order-stats'
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const fileExtension = '.xlsx'
    const products = data.ordered_items.map((val) => {
      return {
        'Product Name': `${val.name}(${val.unit})`,
        Times: val.orders,
        'Value Purchased': val.total,
      }
    })
    const inputs = data.input_categories.map((val) => {
      return {
        Category: `${val.name}`,
        Times: val.qty,
        'Value Purchased': val.total,
      }
    })

    const returningFarmers = data.returning_farmers.map((val) => {
      return {
        Name: `${val.name} `,
        District: val.district,
        Times: val.orders,
        'Value Purchased': val.total,
        'Customer Segment': val.segment,
      }
    })

    // write top ordered products
    const ws1: XLSX.WorkSheet = XLSX.utils.json_to_sheet([{}])
    XLSX.utils.sheet_add_json(ws1, [{ note: 'ALL ORDERED PRODUCTS' }], {
      header: ['note'],
      skipHeader: true,
      origin: `A2`,
    })
    origin += 1
    XLSX.utils.sheet_add_json(ws1, products, { origin: `A4` })

    // write top ordered products
    const ws2: XLSX.WorkSheet = XLSX.utils.json_to_sheet([{}])
    XLSX.utils.sheet_add_json(ws2, [{ note: 'ALL INPUT CATEGORIES' }], {
      header: ['note'],
      skipHeader: true,
      origin: `A2`,
    })
    XLSX.utils.sheet_add_json(ws2, inputs, { origin: `A4` })

    // write ALL RETURNING CUSTOMERS (HAVING MORE THAN ONE ORDER)
    const ws3: XLSX.WorkSheet = XLSX.utils.json_to_sheet([{}])
    XLSX.utils.sheet_add_json(
      ws3,
      [{ note: 'ALL RETURNING CUSTOMERS (HAVING MORE THAN ONE ORDER)' }],
      {
        header: ['note'],
        skipHeader: true,
        origin: `A2`,
      }
    )
    XLSX.utils.sheet_add_json(ws3, returningFarmers, { origin: `A4` })
    origin += products.length

    const wb: XLSX.WorkBook = {
      Sheets: {
        'ALL ORDERED PRODUCTS': ws1,
        'ALL INPUT CATEGORIES': ws2,
        'ALL RETURNING CUSTOMERS': ws3,
      },
      SheetNames: [
        'ALL ORDERED PRODUCTS',
        'ALL INPUT CATEGORIES',
        'ALL RETURNING CUSTOMERS',
      ],
    }
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const fileData: Blob = new Blob([excelBuffer], { type: fileType })
    FileSaver.saveAs(fileData, fileName + fileExtension)
  }

  close() {
    this.show = false
    setTimeout(
      () => this.router.navigate(['.'], { relativeTo: this.route.parent }),
      100
    )
  }

  public get data$() {
    return this.orderService.orderSummary
  }

  async onRangeChange(_value: Date[]) {
    this.orderService.summaryDateRange = this.dateRange
    await this.orderService.getOrderStats().toPromise()
  }
}
